import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid, TextField, MenuItem, FormControl, InputLabel, Select, Button, Avatar } from "@mui/material";
import * as CategoryActions from '../../../redux/actions/categoryAction.js';
import * as SubCategoryActions from '../../../redux/actions/subCategoryAction.js';
import * as SancharActions from '../../../redux/actions/sancharAction';
import logo_icon from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';

const AddPodcast = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { categoryData } = useSelector(state => state.categoryReducer);
  const { subCategoryData, subCatgeoryDataByCategoryId } = useSelector(state => state.subCategoryReducer);
  const redirectCategoryData = categoryData.filter(value => value?.redirect_page === 'Podcast');   //* Redirect Category Data For Category Name Option

  const [podcastDetail, setPodcastDetail] = useState({ categoryId: '', subCategoryId: '', podcastName: '', link: '', artist: '', duration: '', description: '', type: '' });
  const [inputFieldError, setInputFieldError] = useState({ categoryId: '', subCategoryId: '', podcastName: '', link: '', artist: '', duration: '', description: '', image: '' });
  const [image, setImage] = useState({ file: logo_icon, bytes: "" });
  const [audio, setAudio] = useState({ file: null, bytes: "" });
  const [trending, setTrending] = useState(false);

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setPodcastDetail({ ...podcastDetail, [name]: value });
  };

  //* Handle Image
  const handleImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0]?.size < 1 * 1024 * 1024) {
        setImage({
          file: URL.createObjectURL(e.target.files[0]),
          bytes: e.target.files[0],
        });
      } else {
        alert("Please upload image having size less than 1 MB")
      }
    }

    handleInputFieldError("image", null)
  };

  //* Handle Audio
  const handleAudio = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0]?.size < 1 * 1024 * 1024) {
        setAudio({
          file: URL.createObjectURL(e.target.files[0]),
          bytes: e.target.files[0],
        });

      } else {
        alert("Please upload audio having size less than 1 MB")
      }
    }
    handleInputFieldError("audio", null);
  };

  //! Handle Validation
  const handleValidation = () => {
    let isValid = true;
    const { podcastName, categoryId, subCategoryId, description, link, artist, duration, type } = podcastDetail;
    const { bytes: imageBytes } = image;
    const { bytes: audioBytes } = audio;

    if (!categoryId) {
      handleInputFieldError("categoryId", "Please Select Category Name")
      isValid = false;
    }
    if (!subCategoryId) {
      handleInputFieldError("subCategoryId", "Please Select Sub Category Name")
      isValid = false;
    }
    if (!podcastName) {
      handleInputFieldError("podcastName", "Please Enter Podcast Name")
      isValid = false;
    }
    if (!type) {
      handleInputFieldError("type", "Please Select Type")
      isValid = false;
    }
    if (type == "audio") {
      if (!imageBytes) {
        handleInputFieldError("image", "Please Select Image");
        isValid = false;
      }
      if (!audioBytes) {
        handleInputFieldError("audio", "Please Select Audio File");
        isValid = false;
      }
    }
    if (type == 'video') {
      if (!link) {
        handleInputFieldError("link", "Please Enter Link")
        isValid = false;
      }
    }
    if (!artist) {
      handleInputFieldError("artist", "Please Enter Artist Name")
      isValid = false;
    }
    if (!duration) {
      handleInputFieldError("duration", "Please Enter Duration")
      isValid = false;
    }
    if (!description) {
      handleInputFieldError("description", "Please Enter Description")
      isValid = false;
    }
    return isValid;
  };

  //! Handle Submit - Creating Podcast
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      console.log("Podcast Data :: ", { ...podcastDetail, trending, image: image?.bytes })
      const { categoryId, subCategoryId, podcastName, link, description, artist, duration, type } = podcastDetail;

      let formData = new FormData()
      formData.append("audioCategoryId", categoryId)
      formData.append("audioSubCategoryId", subCategoryId)
      formData.append("title", podcastName)
      formData.append("type", type)
      type == 'video' && formData.append("url", link);
      formData.append("artist", artist);
      formData.append("duration", duration);
      formData.append("is_trending", trending);
      formData.append("status", 'Active');
      formData.append("description", description);
      type == 'audio' && formData.append("artwork", image?.bytes);
      type == 'audio' && formData.append("audio", audio?.bytes);

      const payload = {
        data: formData,
        onComplete: () => navigate("/podcast")
      }

      console.log(payload)

      //! Dispatching API for Creating Podcast
      dispatch(SancharActions.createPodcast(payload))
    }
  };

  useEffect(() => {
    //! Dispatching API for Getting Category
    dispatch(CategoryActions.getCategory())
  }, []);

  useEffect(() => {
    //! Dispatching API for Getting Sub Category
    podcastDetail?.categoryId && dispatch(SubCategoryActions.getSubCategoryByCategoryId({ categoryId: podcastDetail?.categoryId }))
  }, [podcastDetail?.categoryId]);

  return (
    <>
      <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
          <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Add Podcast</div>
          <div onClick={() => navigate("/podcast")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
        </div>

        <Grid container sx={{ alignItems: 'flex-start' }} spacing={3}>
          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Category Name</InputLabel>
              <Select
                label="Select Category Name" variant="outlined" fullWidth
                name='categoryId'
                value={podcastDetail?.categoryId}
                onChange={handleInputField}
                error={inputFieldError?.categoryId ? true : false}
                onFocus={() => handleInputFieldError("categoryId", null)}
              >
                <MenuItem disabled>---Select Category---</MenuItem>
                {redirectCategoryData.map((value, index) => <MenuItem key={index} value={value?._id}>{value?.category_name}</MenuItem>)}
              </Select>
            </FormControl>
            {inputFieldError?.categoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.categoryId}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Sub Category</InputLabel>
              <Select
                label="Select Sub Category" variant="outlined" fullWidth
                name='subCategoryId'
                value={podcastDetail?.subCategoryId}
                onChange={handleInputField}
                error={inputFieldError?.subCategoryId ? true : false}
                onFocus={() => handleInputFieldError("subCategoryId", null)}
              >
                {subCatgeoryDataByCategoryId.length == 0 ? <MenuItem disabled>---Please First Select category---</MenuItem> : <MenuItem disabled>---Select Sub Category---</MenuItem>}
                {subCatgeoryDataByCategoryId && subCatgeoryDataByCategoryId.length == 0 ? <MenuItem disabled>You don't have Sub category</MenuItem> : subCatgeoryDataByCategoryId?.map(value => (<MenuItem key={value?._id} value={value?._id}>{value?.sub_category_name}</MenuItem>))}
              </Select>
            </FormControl>
            {inputFieldError?.subCategoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.subCategoryId}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Type</InputLabel>
              <Select
                label="Select Type" variant="outlined" fullWidth
                name='type'
                value={podcastDetail?.type}
                onChange={handleInputField}
                error={inputFieldError?.type ? true : false}
                onFocus={() => handleInputFieldError("type", null)}
              >
                <MenuItem disabled>---Please Select Type---</MenuItem>
                <MenuItem value={'audio'}>Audio</MenuItem>
                <MenuItem value={'video'}>Link</MenuItem>
              </Select>
            </FormControl>
            {inputFieldError?.type && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.type}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Podcast Name" variant='outlined' fullWidth
              name='podcastName'
              value={podcastDetail?.podcastName}
              onChange={handleInputField}
              error={inputFieldError.podcastName ? true : false}
              helperText={inputFieldError.podcastName}
              onFocus={() => handleInputFieldError("podcastName", null)}
            />
          </Grid>

          {podcastDetail?.type == 'audio' && <>
            <Grid item lg={6} sm={6} md={12} xs={12} >
              <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
                <Grid item xs={2} >
                  <Avatar src={image.file} style={{ width: 40, height: 40 }} />
                </Grid>
                <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                  Upload Artwork
                  <input onChange={handleImage} hidden accept="image/*" type="file" />
                </Grid>
              </Grid>
              {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.image}</div>}
            </Grid>

            <Grid item lg={6} md={6} xs={12}>
              <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
                <Grid component="label" item xs={12} style={{ padding: "10px", textAlign: "center", color: "#666666", border: "1px solid #C4C4C4", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                  {audio?.bytes ? audio?.bytes?.name : 'Upload Podcast Audio'}
                  <input onChange={handleAudio} hidden accept="audio/*" type="file" />
                </Grid>
              </Grid>
              {inputFieldError.audio && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError.audio}</div>}
            </Grid>
          </>}

          {podcastDetail?.type == 'video' && <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Podcast Link" variant='outlined' fullWidth
              name='link'
              value={podcastDetail?.link}
              onChange={handleInputField}
              error={inputFieldError.link ? true : false}
              helperText={inputFieldError.link}
              onFocus={() => handleInputFieldError("link", null)}
            />
          </Grid>}

          <Grid item lg={6} md={6} xs={12} >
            <div style={{ display: "flex", gap: "20px", border: "1px solid #C4C4C4", padding: "16px 13.5px", borderRadius: "5px" }}>
              <label style={{ cursor: "pointer", color: "#666666", fontFamily: "Philosopher", fontSize: "13.5px", color: "#667284" }} htmlFor="layout-template">Trending Podcast</label>
              <input onClick={(e) => setTrending(e.target.checked)} style={{ cursor: "pointer", marginTop: "0px", padding: "0px" }} id='layout-template' type="checkbox" />
            </div>
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12} >
            <TextField
              label="Artist" variant='outlined' fullWidth
              name='artist'
              value={podcastDetail?.artist}
              onChange={handleInputField}
              error={inputFieldError.artist ? true : false}
              helperText={inputFieldError.artist}
              onFocus={() => handleInputFieldError("artist", null)}
            />
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12} >
            <TextField
              label="Duration" variant='outlined' fullWidth
              name='duration'
              value={podcastDetail?.duration}
              onChange={handleInputField}
              error={inputFieldError.duration ? true : false}
              helperText={inputFieldError.duration}
              onFocus={() => handleInputFieldError("duration", null)}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12} >
            <TextField
              label="Description" variant='outlined' fullWidth
              name='description'
              value={podcastDetail?.description}
              onChange={handleInputField}
              error={inputFieldError.description ? true : false}
              helperText={inputFieldError.description}
              onFocus={() => handleInputFieldError("description", null)}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container sx={{ justifyContent: "space-between" }}>
              <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default AddPodcast;